export const EURO_CURRENCIES = ['EUR', '€', 'EURO'];
export const formatPrice = (price, addCurrency, currency = 'EUR', vatEnabled = true, monthly = false, translate = () => null) => {
    const formattedPrice = stripTrailingZeroes(replaceDotWithComma(formatToTwoDecimalPlacesRoundingUp(price)));
    return addCurrency ? `${formattedPrice} ${formatCurrency(formattedPrice, currency, vatEnabled, monthly, translate)}` : formattedPrice;
};
export const formatToTwoDecimalPlacesRoundingUp = (price) => {
    return price.toFixed(2);
};
export const stripTrailingZeroes = (price) => {
    return price.endsWith(',00') ? price.substr(0, price.length - 3) : price;
};
export const replaceDotWithComma = (price) => {
    return price.toString().replace(/[.]/, ',');
};
export const renderAddedVat = (translate) => {
    return ` + ${translate('price.vat')}`;
};
export const getApplicablePrice = (price, priceWithoutTax, vatEnabled) => {
    let applicablePrice;
    if (!vatEnabled) {
        applicablePrice = asNumber(priceWithoutTax);
        if (applicablePrice == null) {
            applicablePrice = withoutTax(asNumber(price));
        }
    }
    else {
        applicablePrice = asNumber(price);
    }
    return applicablePrice;
};
const withoutTax = (price) => {
    const vatRate = Date.now() < +new Date('2025-07-01') ? 1.22 : 1.24;
    if (price == null) {
        return null;
    }
    return price / vatRate;
};
const asNumber = (price) => {
    if (!price) {
        return null;
    }
    return Number.parseFloat(price);
};
const formatCurrency = (val, currency, vatEnabled, monthly, translate) => {
    const euroCurrency = monthly ? `€/${translate('price.months')}` : '€';
    let renderedCurrency = !currency || EURO_CURRENCIES.includes(currency) ? euroCurrency : currency;
    if (val !== '0' && !vatEnabled) {
        renderedCurrency += renderAddedVat(translate);
    }
    return renderedCurrency;
};
//# sourceMappingURL=PriceUtil.js.map